export default function PHP_Syllabus() {
  return (
    <div>
      <h1>PHP_Syllabus</h1>
    </div>
  );
}
